import { downloadData } from 'aws-amplify/storage';
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';

const Context = createContext({});

export default function GeneralSettingProvider({ children }) {
  const [generalSetting, setGeneralSetting] = useState();
  const [defaultBounding, setDefaultBounding] = useState();
  useEffect(() => {
    getGeneralSetting();
    getDefaultBounding();
  }, [])

  const getGeneralSetting = async () => {
    try {
      const { body } = await downloadData({ key: 'setting/general_setting.json' }).result;
      const setting = JSON.parse(await body.text());
      setGeneralSetting(setting);
      document.title = setting.appTitle || '冠水監視';
    }
    catch (e) {
      console.error("ERROR", e);
    }
  }

  const getDefaultBounding = async () => {
    try {
      const { body } = await downloadData({ key: 'setting/default_bounding.json' }).result;
      const bounding = JSON.parse(await body.text());
      setDefaultBounding(bounding);
    }
    catch (e) {
      console.error("ERROR", e);
    }
  }

  return (
    <Context.Provider value={{ generalSetting, defaultBounding, setGeneralSetting }}>
      {children}
    </Context.Provider>
  );
}

export const useGeneralSetting = () => useContext(Context);
